module.exports = __webpack_public_path__ + "static/img/200001.793b44b1.png";